export default {
  ADD_CURRICULUM_URL: (state, payload) => state.curriculum_filename = payload,
  CLEAR_CURRICULUM_STATE: state => (state.curriculum_filename = null),
}